// extracted by mini-css-extract-plugin
module.exports = {"menu":"_17XdgH2h","categoryContainer":"-NKV8259","categoryTitle":"_3YwPK_v8","linkContainer":"_1C-a8R4l","link":"_3uvxevlt","linkGroup":"_2dcalJU0","isOpen":"_2dsyaQ_3"};